import React, {
  useState,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "reactstrap";
// import {Form} from "react-bootstrap"
import SikkaInput from "../../common/SikkaInput";
import creditCard from "../../../assets/img/icons/icon-payment-methods.png";
import MaskedInput from "react-text-mask";
import { CapitalizeString } from "./RegisterPayment";
import { Form } from "react-bootstrap";

const CreditPaymentForm = (
  {
    register,
    errors,
    form_name,
    formRef,
    watch,
    setError,
    clearError,
    setValue,
    currentFormValue,
  },
  ref
) => {
const [isCvvHovered, setIsCvvHovered] = useState(false);

  return (
    <>
      {/* ref={formRef} onSubmit={handleSubmit(HandlePaymentCardForm)} */}
      <Form id={`${form_name}-hook-form`} ref={formRef}>
        <Row>
          <Col>
            <MaskedInput
              mask={[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                " ",
                /\d/,
                /\d/,
                /\d/,
              ]}
              guide={false}
              placeholder="XXXX XXXX XXXX XXXX"
              id={`${form_name}_card_number`}
              name={`${form_name}_card_number`}
              defaultValue={currentFormValue?.[`${form_name}_card_number`]}
              render={(ref, props) => {
                return (
                  <>
                    <SikkaInput
                      label="Card Number*"
                      // id={`${form_name}_card_number`}
                      // name={`${form_name}_card_number`}
                      type="text"
                      // placeholder="Card/Debit Card Number"
                      innerRef={ref}
                      errors={errors}
                      {...props}
                    />
                  </>
                );
              }}
              {...register(`${form_name}_card_number`, {
                required: "Card Number is required",
                validate: (value) => {
                  // const isValidCardRegex = /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;

                  const cleanValue = value
                    .trim()
                    .replace(/\s/g, "")
                    .trim();

                  const cardLengths = [13, 14, 15, 16, 17, 18, 19];

                  return (
                    // isValidCardRegex.test(cleanValue) ||
                    cardLengths.includes(cleanValue.length) ||
                    "Invalid Card Number"
                  );
                },
              })}
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  clearError(e.target.name);
                  setValue(
                    e.target.name,
                    e.target.value.trim().replace(/\s/g, "")
                  );
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <MaskedInput
              mask={[/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
              guide={false}
              placeholder="MM/YYYY"
              id={`${form_name}_card_expiration_date`}
              name={`${form_name}_card_expiration_date`}
              defaultValue={
                currentFormValue?.[`${form_name}_card_expiration_date`]
              }
              render={(ref, props) => {
                return (
                  <>
                    <SikkaInput
                      label="Expiration Date*"
                      name={`${form_name}_card_expiration_date`}
                      id={`${form_name}_card_expiration_date`}
                      type="text"
                      placeholder="MM/YYYY"
                      innerRef={ref}
                      errors={errors}
                      {...props}
                    />
                  </>
                );
              }}
              {...register(`${form_name}_card_expiration_date`, {
                required: "Expiration Date is required (MM/YYYY).",
              })}
              onBlur={(e) => {
                if (!e.target.value.trim()) {
                  setError(
                    e.target.name,
                    "custom",
                    `${CapitalizeString(
                      e.target.name
                    )} field should not have whitespace as value.`
                  );
                } else {
                  const dateValue = e.target.value.split("/");
                  const monthValue = dateValue[0];
                  const yearValue = dateValue[1];
                  const currentDate = new Date();
                  const currentYear = currentDate.getFullYear();
                  const currentMonth = currentDate.getMonth() + 1;

                  if (Number(monthValue) > 12 || Number(monthValue) < 1) {
                    setError(
                      e.target.name,
                      "custom",
                      "A month value cannot be less than 1 or greater than 12."
                    );
                  } else if (
                    Number(yearValue) < currentYear ||
                    (Number(yearValue) === currentYear && Number(monthValue) < currentMonth)
                  ) {
                    setError(
                      e.target.name,
                      "custom",
                      "Please enter a valid expiration date."
                    );
                  } else {
                    clearError(e.target.name);
                    setValue(e.target.name, e.target.value.trim());
                  }
                }
              }}
            />
          </Col>
          <Col>
            <div
              onMouseEnter={() => setIsCvvHovered(true)}
              onMouseLeave={() => setIsCvvHovered(false)}
            >
              <SikkaInput
                onChange={(e) => {
                  const digitsOnly = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
                  setValue(e.target.name, digitsOnly);
                }}
                onBlur={(e) => {
                  if (!e.target.value.trim()) {
                    setError(
                      e.target.name,
                      "custom",
                      `${CapitalizeString(
                        e.target.name
                      )} field should not have whitespace as value.`
                    );
                  } else {
                    clearError(e.target.name);
                    setValue(e.target.name, e.target.value.trim());
                  }
                }}
                label="Security Code*"
                placeholder="CVV"
                id="security_code"
                name={`${form_name}_security_code`}
                innerRef={register({
                  required: "CVV is required",
                  validate: (value) => {
                    return (
                      /^\d+$/.test(value?.trim() || "") &&
                        value?.trim().length <= 4 ||
                      "Credit card security code (CVV) must be numeric and no more than 4 digits."
                    );
                  },
                })}
                errors={errors}
                type={isCvvHovered ? "text" : "password"}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={4}
              />
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default forwardRef(CreditPaymentForm);
